import { manageEpisodeActionTypes } from '@/admin/components/modals/manageEpisodeModal/Constants';

import type { ManageEpisodeActions } from '@/admin/components/modals/manageEpisodeModal/Actions';
import type { ManageEpisodeModalState } from '@/admin/components/modals/manageEpisodeModal/types';

const initialState: ManageEpisodeModalState = {
	open: false,
	loading: false,
	episodeId: null,
	episodeData: null,
	submitLoading: false,
};

export default function manageEpisodeReducer(
	state = initialState,
	action: ManageEpisodeActions,
): ManageEpisodeModalState {
	switch (action.type) {
		case manageEpisodeActionTypes.GET_ADMIN_EPISODE_DATA_REQUEST:
			return {
				...state,
				loading: true,
			};
		case manageEpisodeActionTypes.GET_ADMIN_EPISODE_DATA_SUCCESS:
			return {
				...state,
				loading: false,
				episodeData: action.payload.episodeData,
			};
		case manageEpisodeActionTypes.GET_ADMIN_EPISODE_DATA_ERROR:
			return {
				...state,
				loading: false,
			};
		case manageEpisodeActionTypes.MANAGE_ADMIN_EPISODE_REQUEST:
			return {
				...state,
				submitLoading: true,
			};
		case manageEpisodeActionTypes.MANAGE_ADMIN_EPISODE_SUCCESS:
			return {
				...state,
				submitLoading: false,
			};
		case manageEpisodeActionTypes.MANAGE_ADMIN_EPISODE_ERROR:
			return {
				...state,
				submitLoading: false,
			};
		case manageEpisodeActionTypes.TOGGLE_MANAGE_EPISODE_MODAL:
			return {
				...state,
				open: action.payload.open,
				episodeId: action.payload.episodeId ?? null,
			};
		case manageEpisodeActionTypes.CLEAN_MANAGE_EPISODE_STATE:
			return initialState;
		default:
			return state;
	}
}
